<template>
  <div class="col-md-12">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('s-p.title', 'Сторінки магазину') }}</h1>
    </div>

    <div class="default-cards-list minimal-list">
      <div class="default-cards-top">
        <div class="name name-category">{{ $static('s-p.name', 'Назва сторінки') }}</div>
        <div class="name name-actions">{{ $static('s-p.actions', 'Редагувати') }}</div>
      </div>
      <div class="default-card-layout" v-for="(page, index) in pages" :key="index" style="cursor: pointer">
        <div class="default-card-content" @click="openEditor(page)">
          <div class="default-card-main">
            <div class="default-card-title">{{ page.title }}</div>
          </div>
          <div class="actions-box">
            <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
              style="white-space: nowrap">
              <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger"
                title="{{$static('iconsbtn.edit', 'Редагувати')}}">
                <span class="icon icon-edit"></span>
              </button>
            </Popper>

          </div>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <!-- EDITOR WRAPPER for other pages-->
    <div class="overlay-editor item-editor">
      <div class="overlay-editor-wrapper" v-if="selected && !selected.popup">
        <div class="panel-top">

          <div class="lang-selector-holder d-flex align-items-center">
            <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
            <LangSelector v-model="lang" />
          </div>

          <a href="javascript:void(0);" class="back_trigger" @click="cancel">
            <span class="icon icon-cross"></span>
          </a>
        </div>
        <TemplateEditor :title="selected.title" :name="selected.name" @cancel="cancel" :lang="lang"></TemplateEditor>

      </div>
    </div>
    <!--END EDITOR WRAPPER for other pages-->
  </Teleport>


  <Teleport to="body">
    <!-- EDITOR WRAPPER for other pages-->
    <div class="overlay-editor popup-editor">
      <div class="overlay-editor-wrapper" v-if="selected?.popup">
        <div class="panel-top">

          <div class="lang-selector-holder d-flex align-items-center">
            <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
            <LangSelector v-model="lang" />
          </div>

          <a href="javascript:void(0);" class="back_trigger" @click="cancel">
            <span class="icon icon-cross"></span>
          </a>
        </div>

        <PopupEditor :title="selected.title" :template="selected.template" :name="selected.name" @cancel="cancel"
          :lang="lang"></PopupEditor>

      </div>
    </div>
    <!--END EDITOR WRAPPER for other pages-->
  </Teleport>


</template>

<script>
import PopupEditor from '@/components/PopupEditor';
import TemplateEditor from '../components/TemplateEditor';
import LangSelector from '../components/LangSelector';

export default {
  name: 'SettingsPages',
  components: { PopupEditor, LangSelector, TemplateEditor },
  data() {
    return {
      lang: '',
      selected: undefined

    }
  },
  computed: {
    pages() {
      return [
        {
          name: 'home',
          title: this.$static('pgs.pg1', 'Головна')
        },
        {
          name: 'about',
          title: this.$static('pgs.pg2', 'О нас')
        },
        {
          name: 'delivery',
          title: this.$static('pgs.pg3', 'Доставка и оплата')
        },
        {
          name: 'policy',
          title: this.$static('pgs.pg4', 'Политика конфединциальности')
        },
        {
          name: 'dostup',
          title: this.$static('pgs.pg5', 'Политика доступности')
        },
        {
          name: 'oferta',
          title: this.$static('pgs.pg6', 'Публичная оферта')
        },
        {
          name: 'modal_onstart',
          popup: true,
          template: {
            delay: true,
            oneTime: true
          },
          title: this.$static('pgs.pg7', 'Pop-up на старті')
        },
        {
          name: 'modal_onclose',
          popup: true,
          template: {
            oneTime: true
          },
          title: this.$static('pgs.pg8', 'Pop-up при спробі закрити магазин')
        }
      ]
    },
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    }
  },

  methods: {
    cancel() {
      this.selected = undefined;
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    openEditor(item) {
      // window.$(event.target).toggleClass('open');
      this.selected = item;
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      if (item.popup) {
        window.$('.overlay-editor.popup-editor').toggleClass('active');
      } else {
        window.$('.overlay-editor.item-editor').toggleClass('active');
      }
    }
  }
}
</script>

<style scoped></style>